import { RootState } from ".";

export const selectAuth = (state: RootState) => state.auth;
export const selectMelding = (state: RootState) => state.melding;
export const selectToast = (state: RootState) => state.toast;
export const selectMetadata = (state: RootState) => state.meta;
export const selectSearch = (state: RootState) => state.search;
export const selectStepper = (state: RootState) => state.stepper;
export const selectDossier = (state: RootState) => state.dossier;
export const selectVerwerkingsoverzicht = (state: RootState) => state.verwerkingsoverzicht;
